import { CellFailuresAlert } from "@/components/cells/cell-failures-alert";
import { cellNotLoadedHeading } from "@/lib/cells/cell-statistics";
import type { Cell } from "@/lib/cells/cells";
import type { CellFailure } from "@/lib/cells/cell-tenants";
import type { CellScope } from "@/hooks/use-cell-scope";

/**
 * The warnings an agent page shows when a cell's data is missing, so a total
 * from fewer cells is never shown as the whole.
 */
export function CellScopeAlerts({
  scope,
  failures,
  loadedCells,
  isLoading,
}: {
  scope: CellScope;
  /** Cells whose page data failed. */
  failures: CellFailure[];
  /** Cells whose page data loaded. */
  loadedCells: Cell[];
  isLoading: boolean;
}) {
  return (
    <>
      {scope.exclusionsIncomplete && (
        <CellFailuresAlert
          failures={scope.tenantFailures}
          heading={(cell) =>
            `${cell.residency} tenants didn't load - other cells' numbers may include copies of ${cell.residency} tenants' data`
          }
          signInInNewTab
        />
      )}
      {scope.tenantCellUnknown && (
        <CellFailuresAlert
          failures={scope.tenantFailures}
          heading={(cell) =>
            `Can't tell which cell this tenant is in: ${cell.residency} tenants didn't load`
          }
          signInInNewTab
        />
      )}
      <CellFailuresAlert
        failures={
          isLoading
            ? []
            : failures.filter(
                // A cell whose tenants didn't load is already warned about above.
                ({ cell }) =>
                  !(scope.exclusionsIncomplete || scope.tenantCellUnknown) ||
                  !scope.tenantFailures.some((f) => f.cell.id === cell.id),
              )
        }
        heading={(cell) => cellNotLoadedHeading(cell, loadedCells)}
        signInInNewTab
      />
    </>
  );
}
